import { Injectable } from '@jkhy/frontend-utils/di';
import {
    NotificationConfigurationClient,
    NotificationConfigurationModelDto,
} from '@treasury/api/channel';
import { AccountService } from './account.service';
import { NotificationConfiguration, UserAccount } from './types';

@Injectable()
export class UserProfileService {
    constructor(
        private readonly service: AccountService,
        private readonly notificationConfigService: NotificationConfigurationClient
    ) {}

    public async getCurrentUserProfile() {
        const dto = await this.service.getCurrentUserAccountSettings();

        return new UserAccount(dto);
    }

    public async updateCurrentUserProfile(userProfile: UserAccount) {
        this.service.resetCurrentUserAccountCache();

        const dto = userProfile.toDto();
        const response = await this.service.updateCurrentUserAccountSettings(dto);
        const { status, message, errorCode } = response;

        // TODO: create a bespoke type we own; for now, return just what is needed by the view
        return {
            status,
            message,
            errorCode,
        };
    }

    public async getNotificationConfiguration() {
        const response = await this.notificationConfigService.notificationConfigurationGet();
        return new NotificationConfiguration(response.data);
    }

    public async updateNotificationConfiguration(
        notificationConfiguration: NotificationConfigurationModelDto
    ) {
        const response =
            await this.notificationConfigService.notificationConfigurationPut(
                notificationConfiguration
            );

        return new NotificationConfiguration(response.data);
    }
}
